import React from 'react'
import { connect } from 'react-redux'
import { withRouter, Redirect, Link } from 'react-router-dom'
import { Modal, Button, Alert } from 'react-bootstrap';
import is from 'is_js';
import * as moment from 'moment';
import * as settings from '../globals/settings'
import * as digitalIdApi from '../api/digitalIdApi'
import Footer from '../components/footer'
import HelpInfo from '../components/helpInfo'
import {
    validatePassword
} from '../util/validation'

import genders from '../util/genders';
import phoneTypes from '../util/phoneTypes';


import ReactGA from 'react-ga'

import { doPasswordChange, setFakeLoginState, fakeAuth } from '../actions/auth'
import Loading from '../components/loading'

// FIXME Remove
import { fakeUser, fakeLabResults } from '../util/fakeData'
import { setUser, receiveLabResults, setErrorState, createDeviceId } from '../actions/api'

import NavBar from '../components/navbar'

import '../css/styles.css';

class ChangePasswordScreen extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isChangedError: false,
            passwordChangeErrorMessage: null,
            currentPassword: false,
            newPassword: null,
            confirmPassword: null,
            errCode: null,
            errors: {
                currentPassword: null,
                newPassword: null,
                confirmPassword: null,
            },
        }
    }

    componentDidUpdate(prevProps, prevState){
        if(this.props.strings !== prevProps.strings && prevState.errCode === this.state.errCode && prevState.errCode !== null){
            if(this.state.errCode === 'IIE'){
                this.setState({isRegisterError: true, registerErrorMessage: this.props.strings.REG_ERROR_INVALID_ITEM});
            } else if(this.state.errCode === 'IPE'){
                this.setState({isRegisterError: true, registerErrorMessage: this.props.strings.REG_ERROR_INVALID_PASSWORD});
            } else  if(this.state.errCode === 'UE'){
                this.setState({isRegisterError: true, registerErrorMessage: this.props.strings.REG_ERROR_MESSAGE});
            }
        }
    }

    handleCurrentPasswordChange = (e) => {
        let err = this.state.errors;
        err.currentPassword = null;
        let val = e.target.value.trim();
        if (validatePassword(val)) {
            this.setState({currentPassword: val, errors: err});
        } else {
            err.currentPassword = this.props.strings.REG_ERROR_INVALID_PASSWORD;
            this.setState({currentPassword: e.target.value, errors: err});
        }
    }

    handleNewPasswordChange = (e) => {
        let err = this.state.errors;
        err.newPassword = null;
        let val = e.target.value.trim();
        if (validatePassword(val)) {
            this.setState({newPassword: val, errors: err});
        } else {
            err.newPassword = this.props.strings.REG_ERROR_INVALID_PASSWORD;
            this.setState({newPassword: e.target.value, errors: err});
        }
    }

    handleConfirmPasswordChange = (e) => {
        let err = this.state.errors;
        err.confirmPassword = null;
        let val = e.target.value.trim();
        if (this.state.newPassword !== val) {
            err.confirmPassword = this.props.strings.REG_ERROR_PASSWORD_MISMATCH;
            this.setState({confirmPassword: val, errors: err});
        } else {
            this.setState({confirmPassword: e.target.value, errors: err});
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.setState({isChangedError: false, passwordChangeErrorMessage: null});

        this.props.dispatch(doPasswordChange(this.state.currentPassword, this.state.newPassword))
            .then(() => {
                setTimeout(() => { this.setState({ showModal: true }) }, 1000);
            })
            .catch(err => {
                if(err.code === 'IIE'){
                    this.setState({isRegisterError: true, registerErrorMessage: this.props.strings.REG_ERROR_INVALID_ITEM, errCode: err.code});
                } else if(err.code === 'IPE'){
                    this.setState({isRegisterError: true, registerErrorMessage: this.props.strings.REG_ERROR_INVALID_PASSWORD, errCode: err.code});
                } else if(err.code === 'ARE'){
                    this.setState({isRegisterError: true, registerErrorMessage: this.props.strings.REG_ERROR_MESSAGE, errCode: err.code});
                    this.props.history.push("/");
                } else if(err.code === 'ADE'){
                    this.setState({isRegisterError: true, registerErrorMessage: this.props.strings.REG_ERROR_MESSAGE, errCode: err.code});
                    this.props.history.push("/");
                } else {
                    this.setState({isRegisterError: true, registerErrorMessage: this.props.strings.REG_ERROR_MESSAGE, errCode: err.code});
                }
            });;
    }

    handleCancel = (e) => {
        e.preventDefault();
        this.props.history.push("/");
    }

    // FIXME Not sure what should go here?
    renderError(key) {
        if (this.state.errors[key])  {
            return (
                <div className="invalid-feedback">{this.state.errors[key]}</div>
            );
        } else {
            return null;
        }
    }

    renderErrorClass(key) {
        let c = "form-control";
        if (this.state.errors[key])  {
            c = "form-control is-invalid";
        }
        return c;
    }

    validate(dto) {
        let error = null;
        // Check required fields..
        // All fields are required right now.
        Object.entries(dto).forEach((o) => {
            if (o == null) {
                error = this.props.strings.MISSING_REQUIRED_FIELDS;
            }
        });

        // Check for errors.
        Object.entries(this.state.errors).forEach((e) => {
            if (e[1] !== null) {
                error = e;
            }
        });
        return error;
    }


    render() {
        if (this.props.isError === true) {
            return <Redirect to="error" />
        } else if (this.props.isLoadingChangePassword === true) {
            return <Loading />
        }

        return (
          <div className="container-full">
            <NavBar language={this.props.language}/>
            <div className="container justify-content-center align-items-center">
              <div class="alert alert-info" role="alert">
                  <h4>Change Password</h4>
                  <p>
                    Don't have and account? <Link to="register">Register now</Link>
                  </p>
              </div>
                    <form onSubmit={this.handleSubmit} className="formMargin">
                        <div class="form-group">
                            <label for="current-password-input">{this.props.strings.CURRENT_PASSWORD}</label>
                            <input class={this.renderErrorClass('password')} type="password" id="current-password-input" placeholder={this.props.strings.CURRENT_PASSWORD} onChange={this.handlePasswordChange}/>
                            {this.renderError('password')}
                        </div>
                        <div class="form-group">
                            <label for="confirm-password-input">{this.props.strings.HELP_FIELD_PASSWORD}</label>
                            <HelpInfo helpInfoText={this.props.strings.HELP_FIELD_PASSWORD}/>
                            <input class={this.renderErrorClass('newPassword')} type="password" id="new-password-input" placeholder={this.props.strings.NEW_PASSWORD} onChange={this.handleNewPasswordChange}/>
                            {this.renderError('newPassword')}
                        </div>
                        <div class="form-group">
                            <label for="confirm-password-input">{this.props.strings.CONFIRM_PASSWORD_LABEL}</label>
                            <input class={this.renderErrorClass('confirmPassword')} type="password" id="confirm-password-input" placeholder={this.props.strings.PASSWORD} onBlur={this.handleConfirmPasswordChange}/>
                            {this.renderError('confirmPassword')}
                        </div>
                        <div className="row justify-content-center">
                            <button type="submit" class="btn btn-primary custom-button" >{this.props.strings.SUBMIT_BUTTON_LABEL}</button>
                        </div>
                        <div className="row justify-content-center">
                            <button type="button" class="btn btn-link" onClick={this.handleCancel} >{this.props.strings.CANCEL_BUTTON_LABEL}</button>
                        </div>
                    </form>
            </div>
            <Footer />
          </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        authorizeUrl: state.auth.authorizeUrl,
        isLoadingLogin: state.auth.isLoadingLogin,
        isLoadingRegister: state.auth.isLoadingRegister,
        isChangedError: state.auth.isChangedError,
        isFakeLoggedIn: state.auth.isFakeLoggedIn,
        strings: state.language.strings,
        isError: state.api.isError,
    }
}

const ConnectedChangePasswordScreen = connect(
    mapStateToProps
)(ChangePasswordScreen);

export default withRouter(ConnectedChangePasswordScreen);